import { Injectable } from '@angular/core';
import * as pdfjs from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import {
  TextCleanUpService
} from "@services/file-translations/file-translation-validation/text-clean-up/text-clean-up.service";

@Injectable({
  providedIn: 'root'
})
export class PdfExtractorService {
  constructor(
    private textCleanUpService: TextCleanUpService,
  ) {
    // Using the bundled worker file
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
  }

  async extractTextFromPDF(file: File): Promise<string> {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
      fileReader.onload = async () => {
        try {
          const typedArray = new Uint8Array(fileReader.result as ArrayBuffer);
          const pdf = await pdfjs.getDocument({ data: typedArray, isEvalSupported:false }).promise;

          let fullText = '';
          for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            const textContent = await page.getTextContent();
            const pageText = textContent.items.map((item: any) => item.str).join(' ');
            fullText += pageText + '\n';
          }
          // Clean up the text content
          const cleanedText = this.textCleanUpService.createSample(fullText);
          resolve(cleanedText);
        } catch (err) {
          reject(err);
        }
      };

      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(file);
    });
  }
}
